import React from "react";
import classNames from "classnames/bind";

import { ReactComponent as Check } from "icons/checkbox_check.svg";

import styles from "./Checkbox.module.css";

const cx = classNames.bind(styles);

type Props = Omit<React.HTMLProps<HTMLInputElement>, "type" | "className">;

export const Checkbox: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <label className={cx("container")}>
      <span className={cx("inputWrapper")}>
        <input {...rest} className={cx("input")} type="checkbox" />
        <Check className={cx("check")} />
      </span>
      <div className={cx("text")}>{children}</div>
    </label>
  );
};
